import { Identity } from '@schibsted/account-sdk-browser';
import { getFullUrlTo } from '@client/util/uri';

export const isIdentityInitialized = () => window.schIdentity && window.schIdentity instanceof Identity;

export const setGlobalIdentity = (identity) => {
    if (!(identity instanceof Identity)) {
        console.warn('setGlobalIdentity: Expected Identity instance, received:', identity); // eslint-disable-line no-console
        return;
    }
    window.schIdentity = identity;
};

/**
 * Ensure Identity is initialized, create default if needed
 * @returns {Identity}
 */
export const ensureIdentity = (config) => {
    if (isIdentityInitialized()) {
        return window.schIdentity;
    }

    const defaultConfig = {
        ...CONFIG.spid,
        redirectUri: getFullUrlTo('/login'),
    };
    const identity = new Identity(config || defaultConfig);
    setGlobalIdentity(identity);

    return identity;
};
